module.exports = __webpack_public_path__ + "img/main_17.b0920cb6.jpg";